import React, { useState } from 'react';
import Autocomplete from 'react-google-autocomplete';

const PlacesWithStandaloneSearchBox = ({ location, isCheckout, handleClose }) => {
  const [street, updateStreet] = useState(localStorage.getItem('street') || '');
  const [deliveryAddress, updateDeliveryAddress] = useState(
    ''
  );

  const handleStreet = (e) => {
    if (isCheckout) {
      updateDeliveryAddress(e.target.value);
    } else {
      updateStreet(e.target.value);
    }
  };
  return (
    <>
      <Autocomplete
        ref={location}
        className="form-control"
        id="autocomplete"
        value={isCheckout ? deliveryAddress : street}
        style={{
          boxSizing: `border-box`,
          border: `1px solid transparent`,
          width: `100%`,
          height: `50px`,
          padding: `0 12px`,
          borderRadius: `3px`,
          boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
          fontSize: `14px`,
          outline: `none`,
          zIndex: '10000'
        }}
        onChange={handleStreet}
        onPlaceSelected={(place) => {
          if (place && place.geometry && place.geometry.location) {
            const latValue = place.geometry.location.lat().toString();
            const lngValue = place.geometry.location.lng().toString();
            if (isCheckout) {
              updateDeliveryAddress(place.formatted_address);
            }
            updateStreet(place.formatted_address);
            localStorage.setItem('latitude', latValue);
            localStorage.setItem('longitude', lngValue);
            localStorage.setItem('street', place.formatted_address);
            let matches = place?.address_components?.filter(
              (address_component) => {
                return ['colloquial_area', 'locality'].some(
                  (word) => ~address_component.types.indexOf(word)
                );
              }
            );
            updateStreet(place.formatted_address);
            if (matches.length) {
              localStorage.setItem('city', matches[0].long_name);
            }
            for (var i = 0; i < place.address_components.length; i++) {
              for (var j = 0; j < place.address_components[i].types.length; j++) {
                if (place.address_components[i].types[j] === 'postal_code') {
                  const pincode = place.address_components[i].long_name;
                  localStorage.setItem('pincode', pincode);
                }
                if (
                  place.address_components[i].types[j] ===
                  'administrative_area_level_1'
                ) {
                  const state = place.address_components[i].long_name;
                  localStorage.setItem('state', state);
                }
                if (place.address_components[i].types[j] === 'country') {
                  const country = place.address_components[i].long_name;
                  localStorage.setItem('country', country);
                }
              }
            }
            if (handleClose) {
              handleClose()
            }
          }
        }}
        types={[]}
        componentRestrictions={{ country: 'au' }}
      />
    </>
  );
};
export default PlacesWithStandaloneSearchBox;
